(function () {
  var breadcrumbObserverStarted = false;
  var sizePillsStyleInjected = false;
  var pointedStarPath = 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z';
  var starHalfId = 0;

  function normalizeAttr(value) {
    return (value || '').trim().replace(/^['"]+|['"]+$/g, '');
  }

  function getScopedElements(scope, selector) {
    var root = scope || document;
    var nodes = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) {
      nodes.unshift(root);
    }
    return nodes;
  }

  function createFlag(flagSrc, flagCountry) {
    var flagWrap = document.createElement('span');
    flagWrap.className = 'mdl-collection-flag-wrap';
    flagWrap.style.display = 'inline-flex';
    flagWrap.style.alignItems = 'center';
    flagWrap.style.justifyContent = 'center';
    flagWrap.style.marginLeft = '0.5rem';
    flagWrap.style.marginTop = '0.125rem';
    flagWrap.style.flex = '0 0 auto';

    var flagImg = document.createElement('img');
    flagImg.className = 'mdl-collection-flag';
    flagImg.src = flagSrc;
    flagImg.alt = flagCountry ? 'Fabriqué en ' + flagCountry : 'Flag';
    flagImg.title = flagImg.alt;
    flagImg.loading = 'lazy';
    flagImg.style.width = '18px';
    flagImg.style.height = '12px';
    flagImg.style.objectFit = 'contain';
    flagImg.style.display = 'block';

    flagWrap.appendChild(flagImg);
    return flagWrap;
  }

  function applyCollectionFlags(scope) {
    var cards = getScopedElements(scope, 'product-card');
    cards.forEach(function (card) {
      var flagSrc = normalizeAttr(card.dataset.productFlagSrc || '');
      if (!flagSrc) return;

      var flagCountry = normalizeAttr(card.dataset.productFlagCountry || '');
      var titleRow =
        card.querySelector('.infos .space-y-auto-size-1 > .flex.justify-between.items-start') ||
        card.querySelector('.infos .flex.justify-between.items-start');
      if (!titleRow || titleRow.querySelector('.mdl-collection-flag-wrap')) return;

      titleRow.appendChild(createFlag(flagSrc, flagCountry));
    });
  }

  function applyProductFlags(scope) {
    var managers = getScopedElements(scope, 'product-manager[data-product-flag-src]');
    managers.forEach(function (manager) {
      var flagSrc = normalizeAttr(manager.dataset.productFlagSrc || '');
      if (!flagSrc) return;

      var flagCountry = normalizeAttr(manager.dataset.productFlagCountry || '') || 'France';
      var details = manager.querySelector('[product-details]');
      if (!details) return;

      var title = details.querySelector('h1');
      if (!title) return;

      var titleRow = title.parentElement;
      if (!titleRow || titleRow.querySelector('.mdl-collection-flag-wrap')) return;

      titleRow.style.display = 'inline-flex';
      titleRow.style.alignItems = 'center';
      titleRow.style.gap = '0.5rem';
      titleRow.style.width = 'auto';
      titleRow.style.maxWidth = 'max-content';
      titleRow.style.flexWrap = 'wrap';

      titleRow.appendChild(createFlag(flagSrc, flagCountry));
    });
  }

  function hideSizePillsDuplicateButton(scope) {
    var managers = getScopedElements(scope, 'collection-manager[data-show-size-pills="true"]');
    managers.forEach(function (manager) {
      var duplicateButton = manager.querySelector('[filters-meta] .indicator');
      if (!duplicateButton) return;

      var allFilterLayers = manager.querySelectorAll('layer-action[layer-id="collection-filters"]');
      var hasVisibleOther = false;
      for (var i = 0; i < allFilterLayers.length; i++) {
        var btn = allFilterLayers[i];
        if (btn.offsetParent !== null && !duplicateButton.contains(btn)) {
          hasVisibleOther = true;
          break;
        }
      }

      if (hasVisibleOther) {
        duplicateButton.style.display = 'none';
      }
    });
  }

  function injectSizePillsStyle(scope) {
    var managers = getScopedElements(scope, 'collection-manager[data-show-size-pills="true"]');
    if (!managers.length || sizePillsStyleInjected) return;

    var existing = document.querySelector('style[data-mdl-size-pills-breadcrumb-style="true"]');
    if (existing) {
      sizePillsStyleInjected = true;
      return;
    }

    var style = document.createElement('style');
    style.setAttribute('data-mdl-size-pills-breadcrumb-style', 'true');
    style.textContent = [
      'main nav[aria-label="breadcrumb"],',
      'main nav.breadcrumbs {',
      '  display: none !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
    sizePillsStyleInjected = true;
  }

  function hideSizePillsBreadcrumb(scope) {
    var managers = getScopedElements(scope, 'collection-manager[data-show-size-pills="true"]');
    if (!managers.length) return;

    var breadcrumbNodes = document.querySelectorAll('main nav[aria-label="breadcrumb"], main nav.breadcrumbs');
    breadcrumbNodes.forEach(function (node) {
      if (node.hasAttribute('hidden') && node.style.display === 'none') return;
      node.style.setProperty('display', 'none', 'important');
      node.setAttribute('hidden', 'hidden');
    });

    if (!breadcrumbObserverStarted) {
      breadcrumbObserverStarted = true;
      var observer = new MutationObserver(function () {
        hideSizePillsBreadcrumb(document);
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  function replaceCollectionStarPaths(scope) {
    var containers = (scope || document).querySelectorAll('product-card .flex.items-center.gap-2 svg, product-card-modal .flex.items-center.gap-2 svg');
    containers.forEach(function (svg) {
      var path = svg.querySelector('path');
      if (!path) return;
      var d = path.getAttribute('d');
      if (!d || d === pointedStarPath) return;

      if (d.indexOf('M23.423') === 0) {
        starHalfId++;
        var id = 'mdl_hs_' + starHalfId;
        svg.innerHTML = ''
          + '<defs><clipPath id="' + id + '"><rect x="12" y="0" width="12" height="24"/></clipPath></defs>'
          + '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="' + pointedStarPath + '"/>'
          + '<path fill="currentColor" fill-rule="evenodd" d="' + pointedStarPath + '" clip-path="url(#' + id + ')"/>';
        return;
      }

      path.setAttribute('d', pointedStarPath);
    });
  }

  function applyFlags(root) {
    var scope = root || document;
    applyCollectionFlags(scope);
    applyProductFlags(scope);
    hideSizePillsDuplicateButton(scope);
    replaceCollectionStarPaths(scope);
  }

  function init(scriptEl) {
    var sectionId = scriptEl && scriptEl.dataset
      ? scriptEl.dataset.collectionFlagSectionId || scriptEl.dataset.productFlagSectionId || ''
      : '';
    var key = 'mdlCollectionFlagsInit_' + (sectionId || 'global');
    if (window[key]) return;
    window[key] = true;

    var manager = document;
    if (sectionId) {
      manager =
        document.querySelector('collection-manager[data-section-id="' + sectionId + '"]') ||
        document.querySelector('product-manager[data-section-id="' + sectionId + '"]') ||
        document;
    }

    applyFlags(manager);
    var observer = new MutationObserver(function () {
      applyFlags(manager);
    });
    observer.observe(manager, { childList: true, subtree: true });
  }

  function boot() {
    var scripts = document.querySelectorAll('script[data-collection-flag-section-id], script[data-product-flag-section-id]');
    scripts.forEach(function (scriptEl) {
      init(scriptEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();